var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M15.6 2.5H3.6C1.608 2.5 0 4.108 0 6.1V13.3C0 15.292 1.608 16.9 3.6 16.9H15.6C17.592 16.9 19.2 15.292 19.2 13.3V6.1C19.2 4.108 17.592 2.5 15.6 2.5ZM13.56 11.296C13.344 11.476 13.044 11.548 12.768 11.476L2.028 8.848C2.328 8.284 2.916 7.9 3.6 7.9H15.6C16.116 7.9 16.584 8.128 16.92 8.488L13.56 11.296ZM17.4 6.604C16.872 6.292 16.26 6.1 15.6 6.1H3.6C2.94 6.1 2.328 6.292 1.8 6.604V6.1C1.8 5.104 2.604 4.3 3.6 4.3H15.6C16.596 4.3 17.4 5.104 17.4 6.1V6.604Z",
          fill: _vm.color,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }